import { useEffect, useRef, useCallback } from "react";
import store from "../store/store";
import { fetchMyaccountLogin } from "../store/Myaccount/myaccountActions";

export const TOKEN_REFRESH_INTERVAL_MS = 35 * 60 * 1000;

export function useTokenRefresh(enabled = true) {
  const timerRef = useRef(null);
  const wasLoadingRef = useRef(false);

  const clearScheduledRefresh = useCallback(() => {
    clearTimeout(timerRef.current);
    timerRef.current = null;
  }, []);

  const scheduleRefresh = useCallback(() => {
    clearScheduledRefresh();

    if (!enabled || !localStorage.getItem("auth-key")) {
      return;
    }

    timerRef.current = setTimeout(async () => {
      if (!localStorage.getItem("auth-key")) {
        return;
      }

      const result = await store.dispatch(fetchMyaccountLogin());

      if (
        fetchMyaccountLogin.fulfilled.match(result) &&
        result.payload?.success
      ) {
        scheduleRefresh();
      }
    }, TOKEN_REFRESH_INTERVAL_MS);
  }, [enabled, clearScheduledRefresh]);

  useEffect(() => {
    if (!enabled) {
      clearScheduledRefresh();
      return;
    }

    scheduleRefresh();

    const unsubscribe = store.subscribe(() => {
      const { isLoading, myaccountLogin, error } =
        store.getState().myaccountLoginInformation || {};
      const refreshCompleted = wasLoadingRef.current && !isLoading;
      wasLoadingRef.current = isLoading;

      if (refreshCompleted && !error && myaccountLogin?.token) {
        scheduleRefresh();
      }
    });

    return () => {
      clearScheduledRefresh();
      unsubscribe();
    };
  }, [enabled, scheduleRefresh, clearScheduledRefresh]);
}
